import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import InputBase from "@mui/material/InputBase";
import TableContainer from "@mui/material/TableContainer";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CustomSubOwnersModal from "./../../../modals/yourAssets/SOI/CustomSubOwnersModal";
import SharesModal from "./../../../modals/yourAssets/SOI/SharesModal";
// Icons
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import CachedIcon from "@mui/icons-material/Cached";

import { useNavigate, useParams } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { alpha, styled } from "@mui/material/styles";
import {
  addRelationship,
  getAllRelations,
  getSharesOfInheritanceList,
  updateSharesOfInheritanceList,
} from "../../../services/yourAssets/ShareOfInheritance";
import { SecondaryButton } from "../../../common/Buttons";

import "../../../components/yourAssets/BOA/BOA.scss";
import "./index.scss";
import { Circles } from "react-loader-spinner";
import { getUserIdFromLocalStorage } from "../../../utils/Utilities";
import { useTranslation } from "react-i18next";

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label   &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.mode === "light" ? "#fcfcfb" : "#2b2b2b",
    border: "1px solid #ced4da",
    fontSize: 16,
    width: "100%",
    padding: "10px 3px",
    textAlign: "center",

    transition: theme.transitions.create([
      "border-color",
      "background-color",
      "box-shadow",
    ]),
    fontFamily: [
      '"WixMadefor"',
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
  },
}));

const AddButton = styled(Button)(({ theme }) => ({
  color: "white",
  backgroundColor: "#C997BC",
  marginTop: "20px",
  "&:hover": {
    backgroundColor: "#D88EC5",
  },
}));

const createData = (
  relationship,
  name,
  shares,
  value,
  dateOfBirth,
  tax,
  inheritanceShareId = ""
) => {
  return {
    id: name.replace(" ", "_") + Math.random(),
    relationship,
    name,
    shares,
    value,
    dateOfBirth,
    tax,
    inheritanceShareId,
    isEditMode: false,
  };
};

const CustomTableCell = ({ row, name, onChange, width }) => {
  const { isEditMode } = row;
  return (
    <TableCell align="center">
      {
        <BootstrapInput
          value={row[name]}
          name={name}
          onChange={(e) => onChange(e, row)}
          style={{ pointerEvents: isEditMode ? "all" : "none", width: "100%" }}
        />
      }
    </TableCell>
  );
};

function valuetext(value) {
  return `${value}°C`;
}

const FinalStep = () => {
  const { t } = useTranslation();

  const [openEditModal, setOpenEditModal] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState({});
  const [isSharesModalOpen, setSharesModalOpen] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [refreshedData, setRefreshedData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [rows, setRows] = React.useState([]);
  const [allRelationships, setAllRelationships] = useState([]);
  const [previous, setPrevious] = React.useState({});
  const navigate = useNavigate();
  const colors = ["#262B3E", "#6B607E", "#957BA0", "#DFC8DB"];
  const handleOpenEditModal = () => setOpenEditModal(true);
  const handleOpenSharesModal = () => {
    setSharesModalOpen(true);
  };
  const handleCloseSharesModal = () => {
    setSharesModalOpen(false);
  };
  const handleCloseEditModal = () => {
    setOpenEditModal(false);
    setSelectedRow({});
  };
  const handleAddRow = () => {
    setOpenEditModal(true);
  };

  const handleDeleteRow = (id) => {
    setRows(rows.filter((item) => item.id !== id));
  };
  const handleEditRow = (id) => {
    setSelectedRow(rows.find((el) => el.id === id));
    setOpenEditModal(true);
  };
  const handleRefresh = () => {
    setRefresh((pre) => !pre);
  };
  const validateShares = () => {
    let sumOfShares = rows.reduce((a, { shares }) => {
      return Number(a) + Number(shares);
    }, 0);

    return sumOfShares <= 100 ? true : false;
  };

  const handleUpdateRow = async (values) => {
    let result;
    let tax = 0;
    if (values.value !== 0) {
      const payload = {
        relationName: values?.relationship,
        amount: values?.value,
        dateOfBirth: values?.dateOfBirth,
      };
      result = await addRelationship(payload);
    }
    if (result?.success) {
      tax = result?.payLoad;
    }
    let { name, relationship, shares, value, dateOfBirth } = values;
    if (values.id) {
      const newRows = rows.map((row) => {
        if (row.id === values.id) {
          return { ...values, tax };
        }
        return row;
      });
      setRows(newRows);
    } else {
      setRows([
        ...rows,
        createData(relationship, name, shares, value, dateOfBirth, tax),
      ]);
    }
  };

  const onToggleEditMode = (id) => {
    setRows((state) => {
      return rows.map((row) => {
        if (row.id === id) {
          return { ...row, isEditMode: true };
        }
        return row;
      });
    });
    handleEditRow(id);
  };
  const onToggleSaveMode = (id) => {
    setRows((state) => {
      return rows.map((row) => {
        if (row.id === id) {
          return { ...row, isEditMode: false };
        }
        return row;
      });
    });
  };

  const onChange = (e, row) => {
    if (!previous[row.id]) {
      setPrevious((state) => ({ ...state, [row.id]: row }));
    }
    const value = e.target.value;
    const name = e.target.name;
    const { id } = row;
    const newRows = rows.map((row) => {
      if (row.id === id) {
        return { ...row, [name]: value };
      }
      return row;
    });
    setRows(newRows);
  };

  const updateSoiList = async () => {
    if (validateShares()) {
      const data = rows.map((el) => {
        return {
          inheritanceShareId: el.inheritanceShareId
            ? el.inheritanceShareId
            : "",
          relationshipName: el.relationship,
          personName: el.name,
          personShares: el.shares,
          personAmount: el.value,
          dateOfBirth: el.dateOfBirth,
          taxAmount: el.tax,
        };
      });
      let uID = getUserIdFromLocalStorage();
      let result = await updateSharesOfInheritanceList(uID, data);
      if (result?.success) {
        // toast.success(
        //   t(
        //     result?.message
        //       .toLowerCase()
        //       .replaceAll(" ", "-")
        //       .replaceAll("/", "-")
        //       .replaceAll(",", "")
        //       .replaceAll("'", "")
        //   )
        // );
      } else if (!result?.success) {
        toast.error(result?.message);
      }
    } else if (!validateShares()) {
      handleOpenSharesModal();
    }
  };

  useEffect(() => {
    const initializeRows = async () => {
      setLoading(true);
      let uID = getUserIdFromLocalStorage();
      const result = await getSharesOfInheritanceList(uID, refreshedData);
      if (result.success) {
        const dateOfBirth = "";
        const newRows = result.payLoad.map((el) =>
          createData(
            el.relationshipName,
            el.personName,
            el.personShares,
            el.personAmount,
            el?.dateOfBirth ? el?.dateOfBirth : dateOfBirth,
            el.taxAmount,
            el.inheritanceShareId
          )
        );
        setRows(newRows);
        setLoading(false);
      } else {
        setLoading(false);
        setError(result);
      }
    };

    initializeRows();
  }, [refresh]);

  useEffect(() => {
    const getRelationships = async () => {
      const result = await getAllRelations();
      if (result.success) {
        setAllRelationships(result.payLoad);
      }
    };

    getRelationships();
  }, []);

  return (
    <>
      <Toaster />
      {isSharesModalOpen && (
        <SharesModal open={true} handleClose={handleCloseSharesModal} />
      )}

      {openEditModal && (
        <CustomSubOwnersModal
          open={openEditModal}
          handleClose={handleCloseEditModal}
          selectedRow={selectedRow}
          addRow={handleUpdateRow}
          totalAmount={rows.reduce((pre, current) => pre + current.value, 0)}
          relationships={allRelationships}
        />
      )}
      {loading ? (
        <Box
          sx={{
            width: "100%",
            height: "60vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#ffffff",
            paddingTop: "4.5rem",
          }}
        >
          <Circles color="#dfc8db" height={80} width={80} />
        </Box>
      ) : error ? (
        <Box
          sx={{
            height: "calc(100vh - 120px) !important",
          }}
        >
          <Typography textAlign="center">{error}</Typography>
        </Box>
      ) : (
        <Box
          sx={{
            marginRight: "8rem",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            backgroundColor: "#ffffff",
            paddingTop: "4.5rem",
          }}
        >
          <Box width="100%" paddingLeft="75px">
            <CachedIcon
              onClick={() => {
                setRefreshedData(true);
                handleRefresh();
              }}
              sx={{ cursor: "pointer" }}
            />
          </Box>
          <TableContainer
            sx={{
              display: "flex",
              justifyContent: "center",
              // width: "800px",
              overflow: "scroll !important",
            }}
            className="summary-table"
          >
            <Table
              sx={{
                "th , td": { border: "none" },
                th: {
                  padding: "12px 7px",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#00000099",
                },
                td: { padding: "4px 7px" },
                width: "90%",
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    align="left"
                    // sx={{
                    //   width: "160px",
                    // }}
                  >
                    {t("input-15")}
                  </TableCell>
                  <TableCell
                    align="center"
                    // sx={{ width: "180px" }}
                  >
                    {t("soi-heading-2")}
                  </TableCell>
                  <TableCell
                    align="center"
                    // sx={{ width: "100px" }}
                  >
                    {t("soi-heading-3")}
                  </TableCell>
                  <TableCell
                    align="center"
                    // sx={{ width: "100px" }}
                  >
                    {t("soi-heading-4")}
                  </TableCell>
                  <TableCell
                    align="center"
                    // sx={{ width: "100px" }}
                  >
                    {t("soi-heading-5")}
                  </TableCell>
                  <TableCell
                    align="center"
                    // sx={{ width: "70px" }}
                  />
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell align="center">
                      <Box className="rounded-border-box" sx={{}}>
                        {row.relationship}
                      </Box>
                    </TableCell>
                    <TableCell align="center">
                      <Box className="rounded-border-box">{row.name}</Box>
                    </TableCell>
                    <TableCell align="center">
                      <Box className="rounded-border-box">
                        {row.shares + "%"}
                      </Box>
                    </TableCell>
                    <TableCell align="center">
                      <Box className="rounded-border-box">
                        {row?.value?.toLocaleString("de-DE")}
                      </Box>
                    </TableCell>
                    <TableCell align="center">
                      <Box className="rounded-border-box">
                        {row?.tax?.toLocaleString("de-DE")}
                      </Box>
                    </TableCell>
                    <TableCell sx={{}}>
                      <DeleteOutline
                        onClick={() => {
                          handleDeleteRow(row.id);
                        }}
                        sx={{ alignSelf: "flex-end" }}
                      />
                      <EditOutlinedIcon
                        onClick={() => {
                          handleEditRow(row.id);
                        }}
                        sx={{ marginLeft: "10px !important" }}
                      />
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  {" "}
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableRow>
                <TableRow>
                  {" "}
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left">
                    <SecondaryButton
                      title={
                        <>
                          <Typography
                            sx={{
                              fontWeight: 900,
                              fontSize: "1.5rem",
                              position: "absolute",
                              top: "-6%",
                              left: "13%",
                              color: "#ffffff",
                            }}
                          >
                            +
                          </Typography>{" "}
                          {t("add")}
                        </>
                      }
                      color="#ffffff"
                      textTransform="initial"
                      fontWeight="normal"
                      bgColor="color.magentaLight1"
                      borderRadius="40px"
                      padding="5px auto"
                      width="105px"
                      border="none"
                      hoverBgColor="color.magentaLight1"
                      marginLeft="none"
                      click={() => {
                        handleAddRow();
                      }}
                    />
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{ width: "100%", marginTop: "70px", padding: "0px 50px" }}>
            <div className="customSlider" style={{ marginBottom: "50px" }}>
              {rows?.map((row, index) => {
                return (
                  <span
                    key={index}
                    style={{
                      width: `${row.shares}%`,
                      backgroundColor: `${colors[index % 4]}`,
                      height: "100%",
                      position: "relative",
                    }}
                  >
                    {index < rows.length - 1 && (
                      <span
                        style={{
                          width: "25px",
                          height: "25px",
                          borderRadius: "50%",
                          border: "1px solid #707070",
                          backgroundColor: "white",
                          position: "absolute",
                          right: "-15px",
                          top: "50%",
                          transform: "translate(0, -50%)",
                          zIndex: "10",
                        }}
                      ></span>
                    )}
                    <div className="user">
                      <p>{row.name}</p>
                      <p style={{ marginTop: "5px" }}>{row.shares}</p>
                    </div>
                  </span>
                );
              })}
            </div>
          </Box>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "9rem",
              marginBottom: "5rem",
            }}
          >
            <SecondaryButton
              borderRadius="10px"
              width="200px"
              click={() => navigate("/")}
            />

            <SecondaryButton
              title={t("save-and-continue")}
              bgColor="color.magentaLight2"
              borderRadius="10px"
              width="200px"
              marginLeft="20px"
              click={() => updateSoiList()}
            />
          </div>
        </Box>
      )}
    </>
  );
};
export default FinalStep;
